import { render, staticRenderFns } from "./distributordata.vue?vue&type=template&id=4c173880"
import script from "./distributordata.vue?vue&type=script&lang=js"
export * from "./distributordata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports